import React from 'react'
import './TimeoutOverlayView.scss'
import {startTimer, reset, stop} from '../modules/timer';
import MAYA from '../../../../maya_api'

import {getLanguageScope} from '../../../../helpers'
const _i18n = getLanguageScope('timeout_overlay');


import {Modal, Header, Button, Icon} from 'semantic-ui-react'

class TimeoutOverlay extends React.Component {
  constructor(props){
    super(props);

    this.close = this.close.bind(this)
  }

  async componentDidMount(){
    console.log('Timer was started');
    startTimer()
  }

  componentWillUnmount(){
    console.log('Timer was stopped');
    stop();
  }

  close(){
    const {closeTimeoutPopup} = this.props;

    closeTimeoutPopup() && reset()
  }

  render(){

    const {showTimeoutPopup, countdown} = this.props;

    return (
      <Modal
        style={{height: 'auto'}}
        open={showTimeoutPopup}
        onClose={this.close}
        basic
        size='small'
      >
        <Header icon='time' content={_i18n('title')}/>
        <Modal.Content>
          <h3>{`${_i18n('description')} ${countdown}`}</h3>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color='red' onClick={() => MAYA.logout()} inverted>
            <Icon name='remove'/> {_i18n('no')}
          </Button>
          <Button color='green' onClick={this.close} inverted>
            <Icon name='checkmark'/> {_i18n('yes')}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default TimeoutOverlay


// WEBPACK FOOTER //
// ./src/components/shared/TimeoutOverlay/components/TimeoutOverlayView.js